import React, { useEffect, useState } from 'react';
import {
  Container,
  SelectedTab,
  SelectTabWrapper,
  Table,
  Title,
  ResultBadge,
  SubRow,
  SubTable,
  ToggleButton,
  Description,
  TableWrapper,
  SelectedTabText
} from './styled';
import { toJS } from 'mobx';

const RecentRecord = ({ data, gameData }) => {
  const [selectedPosition, setSelectedPosition] = useState('home');
  const [recentRecord, setRecentRecord] = useState([]);

  const { recentHomeRecord, recentAwayRecord } = data;
  useEffect(() => {
    setRecentRecord(recentHomeRecord);
  }, []);
  const handleChangePosition = (position) => {
    if (position === 'home') {
      setRecentRecord(recentHomeRecord);
    } else {
      setRecentRecord(recentAwayRecord);
    }
    setSelectedPosition(position);
  };

  const teamData = gameData.detail.getTeamData || null;

  return (
    <Container>
      <Title>최근 5경기</Title>
      <SelectTabWrapper>
        <SelectedTab
          isSelected={selectedPosition === 'home'}
          onClick={() => handleChangePosition('home')}
        >
          <SelectedTabText>{teamData && teamData.home.name}</SelectedTabText>
        </SelectedTab>
        <SelectedTab
          isSelected={selectedPosition === 'away'}
          onClick={() => handleChangePosition('away')}
        >
          <SelectedTabText>{teamData && teamData.away.name}</SelectedTabText>
        </SelectedTab>
      </SelectTabWrapper>
      <TableWrapper>
        <Table>
          <colgroup>
            <col width={60} />
            <col width={90} />
            <col width={25} />
            <col width={15} />
            <col width={25} />
            <col width={90} />
            <col width={110} />
          </colgroup>
          <thead>
            <tr>
              <th>경기일</th>
              <th>홈팀</th>
              <th colSpan={3}>점수</th>
              <th>원정팀</th>
              <th>결과</th>
            </tr>
          </thead>
          <tbody>
            {recentRecord.map((value, key) => {
              return <MatchRow key={key} item={value} />;
            })}
          </tbody>
        </Table>
      </TableWrapper>
      <Description>배당 및 기준점은 베트맨을 기준으로 합니다.</Description>
    </Container>
  );
};

const MatchRow = ({ item }) => {
  const { teamsData, oddsData, date, setScore } = item;
  const [viewSub, setViewSub] = useState(false);

  const handleToggleSub = () => {
    setViewSub(!viewSub);
  };
  return [
    <tr key={'row'} onClick={handleToggleSub} className={viewSub ? 'on' : ''}>
      <td>{date}</td>
      <td>{teamsData.home.name}</td>
      <td className={teamsData.home.winner ? 'winner' : ''}>{setScore.home}</td>
      <td>:</td>
      <td className={teamsData.away.winner ? 'winner' : ''}>{setScore.away}</td>
      <td>{teamsData.away.name}</td>
      <td>
        {oddsData.winLose.home && (
          <ResultBadge position={oddsData.winLose.home.hit ? 'home' : 'away'}>
            {oddsData.winLose.home.hit ? '홈승' : '홈패'}
          </ResultBadge>
        )}
        {oddsData.handicap.home && (
          <ResultBadge position={oddsData.handicap.home.hit ? 'home' : 'away'}>
            {oddsData.handicap.home.hit ? '핸디승' : '핸디패'}
          </ResultBadge>
        )}
        {oddsData.unover.home && (
          <ResultBadge position={oddsData.unover.home.hit ? 'away' : 'home'}>
            {oddsData.unover.home.hit ? '언더' : '오버'}
          </ResultBadge>
        )}
        <ToggleButton viewSub={viewSub} />
      </td>
    </tr>,
    viewSub && (
      <SubRow className={'subRow'} key={'subRow'}>
        <td colSpan={7}>
          <SubTableComp item={item} />
        </td>
      </SubRow>
    )
  ];
};

const SubTableComp = ({ item }) => {
  const { home, away, oddsData, periodScore, totalScore } = item;

  return (
    <SubTable>
      <colgroup>
        <col width={100} />
        <col width={33} />
        <col width={33} />
        <col width={33} />
        <col width={33} />
        <col width={33} />
        <col width={33} />
        <col width={40} />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>1</th>
          <th>2</th>
          <th>3</th>
          <th>연장</th>
          <th>슛아웃</th>
          <th>합계</th>
          <th>기준</th>
        </tr>
      </thead>
      <tbody>
        <TeamRow
          teamData={away}
          position={'AWAY'}
          detail={item}
          handi={oddsData.handicap.option}
          odds={oddsData.winLose.away ? oddsData.winLose.away.odds : null}
        />
        <TeamRow
          teamData={home}
          position={'HOME'}
          detail={item}
          handi={oddsData.unover.option}
          odds={oddsData.winLose.home ? oddsData.winLose.home.odds : null}
        />
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td>{periodScore[1] || 0}</td>
          <td>{periodScore[2] || 0}</td>
          <td>{periodScore[3] || 0}</td>
          <td>{periodScore[4] || 0}</td>
          <td>{periodScore[5] || 0}</td>
          <td>{totalScore}</td>
          <td></td>
        </tr>
      </tfoot>
    </SubTable>
  );
};

const TeamRow = ({ teamData, position, detail, handi, odds }) => {
  const { periodData, name } = teamData;
  let totalScore = 0;
  if (position === 'HOME') {
    totalScore = detail.homeTotalScore;
  } else {
    totalScore = detail.awayTotalScore;
  }

  return (
    <tr>
      <th>{name}</th>
      <td>{(periodData[0] && periodData[0].score) || 0}</td>
      <td>{(periodData[1] && periodData[1].score) || 0}</td>
      <td>{(periodData[2] && periodData[2].score) || 0}</td>
      <td>{(periodData[3] && periodData[3].score) || 0}</td>
      <td>{(periodData[4] && periodData[4].score) || 0}</td>
      <td>{totalScore}</td>
      <td>{handi || '-'}</td>
    </tr>
  );
};

export default RecentRecord;
